module.exports = function() {
  return new Worker(__webpack_public_path__ + "30cff0bd8b192a60ff02.worker.js");
};